import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {PUBLIC_ROUTES} from '../../../../../../shared/routing/public.routes'
import {CLIENT_ROUTES} from '../../../../../../shared/routing/client.routes'
import {PRO_ROUTES} from '../../../../../../shared/routing/pro.routes'
import {LinkService} from '../../../../../i18n/link.service'
import {AuthenticatedUser, AuthStatusService} from '../../../../../auth/auth-status.service'
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser'

@Component({
  selector: 'bgo-login-shortcuts',
  templateUrl: './login-shortcuts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      @reference '../../../../../../../styles/theme.css';

      :host {
        --profile-left-shift: 0.25rem;
      }

      .profile {
        @apply -mx-(--profile-left-shift) flex;
        @apply h-[26px] w-[26px];
        @apply items-center justify-center;
        @apply rounded-full border border-white;
        @apply text-white;
        @apply text-2xs font-semibold;
      }
      .profile--admin {
        @apply bg-gold-400;
      }
      .profile--pro {
        @apply bg-petrol-400;
      }
      .profile--agent {
        @apply bg-vermillon-400;
      }
      .profile--client {
        @apply bg-rivergreen-400;
      }
    `,
  ],
  standalone: false,
})
export class LoginShortcutsComponent {
  @Input() invertedColour = false
  readonly loginIcon = faUser
  readonly loginLink = this.linkService.localizedPathTo(PUBLIC_ROUTES.SIGN_IN)
  readonly proSettingsLink = this.linkService.localizedPathTo(PRO_ROUTES.PRO_SETTINGS)
  readonly clientSettingsLink = this.linkService.localizedPathTo(CLIENT_ROUTES.CLIENT_SETTINGS)

  constructor(
    readonly linkService: LinkService,
    readonly authStatus: AuthStatusService,
  ) {}

  protected userLink(authenticatedUser: AuthenticatedUser | undefined) {
    if (authenticatedUser?.pro) {
      return this.proSettingsLink
    }

    if (authenticatedUser?.client) {
      return this.clientSettingsLink
    }

    return undefined
  }
}
